import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
import { MetaPixel } from '../components/MetaPixel';
export function SalesPage() {
  return <>
      <MetaPixel data-id="element-279" />
      <main className="w-full min-h-screen bg-navy" data-id="element-280">
        <HeroSection data-id="element-281" />
        <PainSection data-id="element-282" />
        <SolutionSection data-id="element-283" />
        <OfferSection data-id="element-284" />
        <Footer data-id="element-285" />
      </main>
    </>;
}